import {Feature} from 'geojson';

type IUrlType = 'list' | 'detail' | 'register' | 'login' | 'passwordReset';

export interface IConfiguration {
  fulltextPlaceholder: string;
  title: string;
  // for server-side logging
  siteName: string;
  // a frontend name for a single site/record
  featureName: string;
  baseUrl: string;
  urls: {
    [index in IUrlType]: string;
  };
  groups: number[];
  style: string;
  useFaviconMapIcons: boolean;
  smartmapsAccessToken: string;
  loadGeoJSONs:
    [
      {
        [geoJsonUrl: string]: string
      }
    ];
}

export class ConfigurationState {
  static configuration: IConfiguration;

  static defaultPageDescription = '';
  static defaultPageTitle = '';

  static url(type: IUrlType): string {
    return ConfigurationState.configuration.baseUrl
      + ConfigurationState.configuration.urls[type];
  }

  static pageDataUrl(path: string): string {
    return ConfigurationState.resolve(`/page_data/${path}`);
  }

  static imageApiUrl(path: string): string {
    return ConfigurationState.resolve(`/api/image/${path}`);
  }

  public static resolve(path: string): string {
    return import.meta.resolve(path);
  }

  /**
   * @param feature
   * @param variant @see imagecache.php
   */
  static siteImgUrl(feature: Feature, variant: 'w480' | 'w480grey' | 'w596' | 'w960'): string | null {
    if (feature.properties?.hasImage) {
      return ConfigurationState.imageApiUrl(`${feature.properties.slug}/${variant}`);
    }

    if (feature.properties?.screenshot_path) {
      return ConfigurationState.pageDataUrl(`${variant}${feature.properties.screenshot_path}`);
    }

    return null;
  }
}
